import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

// Auth Phase 1 (P1-B): the unified "your session ended" experience. Overlays
// whatever page is open — nothing navigates, no form state is lost. Signing
// in resumes the page; "Sign out" clears the session and ProtectedRoute
// sends the user to /login.
const REASONS = {
  SESSION_REVOKED: 'This session was signed out from another device or by an administrator.',
  ACCOUNT_INACTIVE: 'This account has been deactivated.',
  REFRESH_EXPIRED: 'Your session expired after 30 days without use.',
  V1_TOKEN_INVALID: 'Your sign-in expired.',
  SIGNED_OUT_ELSEWHERE: 'You signed out in another tab.'
};

const overlay = {
  position: 'fixed', inset: 0, zIndex: 100000, background: 'rgba(15, 23, 42, 0.82)',
  display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16
};
const card = {
  width: '100%', maxWidth: 400, background: '#0f172a', color: '#e2e8f0', border: '1px solid #334155',
  borderRadius: 12, padding: 28, boxShadow: '0 20px 60px rgba(0,0,0,0.5)', fontFamily: 'inherit'
};
const input = {
  width: '100%', boxSizing: 'border-box', padding: '10px 12px', marginTop: 6, marginBottom: 14,
  borderRadius: 8, border: '1px solid #475569', background: '#1e293b', color: '#f1f5f9', fontSize: 15
};
const primary = { width: '100%', padding: '11px 0', borderRadius: 8, border: 0, background: '#D4A94E', color: '#1a1a1a', fontWeight: 600, fontSize: 15, cursor: 'pointer' };
const secondary = { width: '100%', padding: '9px 0', marginTop: 10, borderRadius: 8, border: '1px solid #475569', background: 'transparent', color: '#cbd5e1', fontSize: 14, cursor: 'pointer' };

const SessionLostModal = () => {
  const { sessionLost, login, logout, user } = useAuth();
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);

  if (!sessionLost) return null;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const result = await login(identifier || user?.email || '', password);
    setBusy(false);
    if (result.success) setPassword('');
  };

  return (
    <div style={overlay} role="dialog" aria-modal="true" aria-labelledby="session-lost-title" data-testid="session-lost-modal">
      <div style={card}>
        <h2 id="session-lost-title" style={{ margin: '0 0 6px', fontSize: 20 }}>Your session ended</h2>
        <p style={{ margin: '0 0 18px', color: '#94a3b8', fontSize: 14 }}>
          {REASONS[sessionLost.code] || 'Please sign in again to continue.'} Your work on this page is kept.
        </p>
        <form onSubmit={submit}>
          <label style={{ fontSize: 13, color: '#94a3b8' }}>Email or phone
            <input style={input} value={identifier} onChange={(e) => setIdentifier(e.target.value)} placeholder={user?.email || ''} autoComplete="username" />
          </label>
          <label style={{ fontSize: 13, color: '#94a3b8' }}>Password
            <input style={input} type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" autoFocus />
          </label>
          <button type="submit" style={primary} disabled={busy}>{busy ? 'Signing in…' : 'Sign in and continue'}</button>
          <button type="button" style={secondary} onClick={logout}>Sign out</button>
        </form>
      </div>
    </div>
  );
};

export default SessionLostModal;
